/**
 * The object that represents and accesses the Retail API
 * This is utilized by the various models to construct the proper urls.
 *
 * Copyright 2015 LightSpeed Retail. All rights reserved.
 */

let URLHelper = {
  /**
   * Return the account id from the current session
   * @returns {*} the account id
   */
  getAccountID() {
    // TODO: Refactor out session behaviour into a module
    return window.merchantos.session.getSystemCustomerID();
  },

  /**
   * Return a string representing the base url for Cloud API
   * @returns {string} base url for REST endpoints, in form <host>/API
   */
  getBaseURL() {
    return '/API';
  },

  /**
   * Compose a string representing the API URL for the specified url fragment.  This method composes a URL of the
   * form: https://{API Host}{url}.
   *
   * @param url           The URL fragment used to construct the API URL (e.g. '/Session').  The string must be
   *                      prefixed with a '/'.
   * @returns {String}    The composed API URL
   */
  getURL(url) {
    return this.getBaseURL() + url;
  },

  /**
   * Return a string representing the base url Cloud API that requires the account id, of the form
   * '<host>/API/Account/<id>'
   * @returns {string} the REST endpoint url that includes the account id
   */
  getBaseAccountURL() {
    return `${this.getBaseURL()}/Account/${this.getAccountID()}`;
  },

  /**
   * Compose a string representing the API URL for the specified url fragment.  This method composes a URL of the
   * form: https://{API Host}/Account/{AccountId}{url}.
   *
   * @param url           The URL fragment used to construct the API URL (e.g. '/Item/1').  The string must be
   *                      prefixed with a '/'.
   * @returns {String}    The composed API URL
   */
  getAccountURL(url) {
    return this.getBaseAccountURL() + url;
  },

  /**
   * Return the shop id for the current session
   *
   * @returns {string} the shop id
   */
  getShopID() {
    // TODO: Refactor out session behaviour into a module
    return window.merchantos.session.getShop().shopID;
  },
};

export default URLHelper;
